import React from "react";

const BranchSelector = ({ branchName, onClick }) => {
  branchName = branchName || "Home branch";
  return (
    <div className="branch-selector" onClick={onClick}>
      <span className="branch-selector-label">Selected branch: </span>
      <span className="selected-branch">{branchName}</span>
    </div>
  );
};

export default BranchSelector;
